<script setup lang="ts">
import { ref } from 'vue'

const isShowVideo = ref(false)
</script>

<template>
    <BaseVideoModal v-model:visible="isShowVideo" />
    <!-- steps -->
    <section
        class="relative w-full flex flex-col items-center pt-[110px] pb-8 lg:pb-[113px] md:pt-[212px] gap-12 bg-white">
        <div
            class="absolute max-w-screen-sm md:max-w-screen-xl mx-auto w-full h-[284px] md:h-[376px] lg:h-full top-[-30px] md:top-[0] lg:top-[-200px] bg-[url(/home/img/home/bg-hero.png)] bg-center bg-cover bg-no-repeat">
        </div>
        <h2 class="z-10 text-[#0F1114] text-[26px] text-center lg:text-[32px] font-bold">
            با سه قدم ساده در پی‌جیب تبادل ارز انجام دهید.
        </h2>
        <ul class="z-10 flex flex-col lg:flex-row items-center gap-6 lg:gap-16">
            <li class="flex flex-col items-center gap-4">
                <img class="w-[64px] h-[64px]" src="/home/img/home/payjibSteos1.svg" alt="ثبت‌نام سریع">
                <h3 class="text-[24px] lg:text-3xl text-wrap text-[#2626BF] font-bold text-center">۱. ثبت‌نام<br
                        class="hidden lg:block">
                    سریع</h3>
                <p class="text-sm text-[#71757A] text-center">
                    یک حساب کاربری بسازید و جزئیات معامله (مقدار<br> ارز، نوع معامله و مقصد) را ثبت کنید.
                </p>
            </li>
            <li class="flex flex-col items-center gap-4 text-center">
                <img class="w-[64px] h-[64px]" src="/home/img/home/payjibSteos2.svg" alt="انتخاب پیشنهاد مناسب">
                <h3 class="text-[24px] lg:text-3xl text-[#2626BF] font-bold">۲. انتخاب پیشنهاد<br
                        class="hidden lg:block"> مناسب</h3>
                <p class="text-sm text-[#71757A]">بین پیشنهادهای موجود، مناسب‌ترین گزینه را<br> انتخاب کنید.</p>
            </li>
            <li class="flex flex-col items-center gap-4 text-center">
                <img class="w-[64px] h-[64px]" src="/home/img/home/payjibSteps3.svg" alt="تأیید و انتقال">
                <h3 class="text-[24px] lg:text-3xl text-[#2626BF] font-bold">۳. تایید و<br class="hidden lg:block">
                    انتقال</h3>
                <p class="text-sm text-[#71757A]">مبلغ را واریز و رسید را آپلود
                    کنید.<br>تبریک! تراکنش شما با موفقیت انجام شد.</p>
            </li>
        </ul>
        <button class="z-10 hidden lg:flex items-center gap-2" @click="isShowVideo = true">
            <img src="/home/img/home/video-octagon.svg" alt="" aria-hidden="true">
            <span class="text-lg font-bold text-[#2E2EE5]">مشاهده ویدئو</span>
        </button>

        <div class="z-10 block lg:hidden px-4">
            <video controls class=" rounded-xl h-[500px" aria-label="ویدئوی آموزش انجام تبادل ارز در پی‌جیب">
                <source src="/home/video/video_2025-05-21_22-34-11.mp4" type="video/mp4" />
                مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
            </video>
        </div>

    </section>
</template>
